<script>
  export let content = {
    activitiesIconImgSrc: '',
    activitiesIconImgAltTxt: '',
    activitiesSectionTitle: '',
    activities: [
      {
        imgSrc: '',
        imgSrcAltTxt: '',
        title: '',
        content: ``,
      }
    ]
  };
</script>

<section class="bg-[#e7f3fd] p-[3rem] font-poppins">

  <div class="flex flex-col items-center mb-16">
    <img
      loading="lazy"
      class="w-[3.7rem] sm:w-[5.5rem] md:w-[6rem]"
      src="{content.activitiesIconImgSrc}"
      alt="{content.activitiesIconImgAltTxt}"
    />
    <h2 class="bg-gradient-to-r from-[#0395FF] via-[#156FF7] to-[#0494F5] bg-clip-text text-transparent text-[3rem] font-bold leading-none pb-2 text-center sm:text-[4.5rem] md:text-[5rem]">
      {content.activitiesSectionTitle}
    </h2>
  </div>

  <div class="flex flex-col items-center justify-items-center gap-[3.5rem] sm:gap-[4.5rem]">
    {#each content.activities as activity, i}
      <div class="flex flex-col justify-center items-center max-w-[40rem] sm:max-w-[54rem] {i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} md:max-w-[105.2rem] md:gap-12">
        <img
          loading="lazy"
          class="w-[22rem] sm:w-[32rem] md:w-full mb-[1rem]"
          src="{activity.imgSrc}"
          alt="{activity.imgSrcAltTxt}"
        />
        <div class="flex flex-col items-center">
          <h3 class="text-[#0158c3] text-[2.4rem] font-semibold mb-[1rem] sm:text-[3.5rem] sm:mb-[2.5rem] md:mb-[0rem] md:self-start">
            {activity.title}
          </h3>
          <p class="text-[#303047] text-[1.4rem] leading-[2rem] text-center sm:text-[2rem] sm:leading-[3rem] md:text-[2.2rem] md:text-left">
            {activity.content}
          </p>
        </div>
      </div>
    {/each}
  </div>
</section>
